/**
 * Controller: RolesPermissionsRemoveModal
 */
angular.module('acme.view.application.roles.permissions.removeModal.controllers', [])
.controller('RolesPermissionsRemoveModalController', [ '$scope', '$uibModalInstance', 'currentPermission', function ($scope, $uibModalInstance, currentPermission) {

    $scope.errors = [];

    $scope.model = {
      id: currentPermission.id,
      name: currentPermission.name
    };

    $scope.init = function() {

    };

    $scope.hasErrors = function() {
      return ($scope.errors.length > 0);
    };

    $scope.done = function() {
      $scope.success();
    };

    $scope.cancel = function () {
      $uibModalInstance.dismiss('cancel');
    };

    $scope.success = function () {
      $uibModalInstance.close(true);
    };

    $scope.init();

  }]);